// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file entities/app/chats/chat_member.proto (package protos.entities.app.chats, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file entities/app/chats/chat_member.proto.
 */
export const file_entities_app_chats_chat_member: GenFile = /*@__PURE__*/
  fileDesc("CiRlbnRpdGllcy9hcHAvY2hhdHMvY2hhdF9tZW1iZXIucHJvdG8SGXByb3Rvcy5lbnRpdGllcy5hcHAuY2hhdHMibwoKQ2hhdE1lbWJlchISCgphY2NvdW50X2lkGAEgASgJEgwKBG5hbWUYAiABKAkSDwoHcGZwX3VybBgDIAEoCRIuCgp1cGRhdGVkX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcGIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message protos.entities.app.chats.ChatMember
 */
export type ChatMember = Message<"protos.entities.app.chats.ChatMember"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string pfp_url = 3;
   */
  pfpUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.entities.app.chats.ChatMember.
 * Use `create(ChatMemberSchema)` to create a new message.
 */
export const ChatMemberSchema: GenMessage<ChatMember> = /*@__PURE__*/
  messageDesc(file_entities_app_chats_chat_member, 0);

